// LRPO-5507 — the leads filter chip strip's client-side lifecycle.
//
// The chips partial is re-rendered server-side and shipped as `chips_html` on
// EVERY DataTables draw, then swapped into the page. The swap used to grab
// `parsed.body.firstElementChild` and replace the `.filter-chips` node with it.
// Whenever LeadFilters raised a warning the partial emitted the warning banner
// FIRST and the chip row SECOND — two top-level siblings — so the banner
// replaced the chip row: every applied chip vanished, the banner duplicated,
// and with `.filter-chips` gone from the DOM no later draw could find its
// lookup target again (the stale warning froze on screen until a hard reload).
//
// The partial now emits ONE stable region wrapper around both blocks, and the
// swap replaces that region wholesale. Extracted here (rather than left inline
// in _table.html.erb) so the invariant is unit-testable; the inline DataTables
// dataSrc callback reaches it through the window bridge at the bottom, the same
// pattern window.leadDrill / window.reportsDayTooltipTitle already use.
export const CHIPS_REGION_ID = "leads-filter-chips-region";

// Replace the whole chips region with the server's freshly-rendered one.
// Returns true when a swap happened. Never partially applies: if either side of
// the swap is missing we leave the DOM exactly as it was.
export function swapFilterChipsRegion(chipsHtml, doc = document) {
  if (!chipsHtml) return false;
  const region = doc.getElementById(CHIPS_REGION_ID);
  if (!region) return false;

  const parsed = new DOMParser().parseFromString(chipsHtml, "text/html");
  const replacement = parsed.getElementById(CHIPS_REGION_ID);
  if (!replacement) return false;

  region.replaceWith(doc.importNode(replacement, true));
  return true;
}

// ONE filter count, TWO surfaces (LRPO-5507 items 18 + 21). The trigger badge
// and the drawer header's "N filters applied" sentence used to be computed from
// different denominators — the badge from the server's chip count, the header
// from the applied param-KEY count — so they disagreed by construction (chips
// collapse the buyer-profile keys into one and emit none for quality_min/max).
// Both are written from this single value now, and the header is refreshed on
// every draw instead of being baked in once at page render.
export function updateFilterCount(count, doc = document) {
  const n = Number(count);
  if (!Number.isFinite(n)) return;

  const badge = doc.querySelector("[data-filter-drawer-trigger] .filter-drawer-trigger__badge");
  if (badge) {
    badge.textContent = String(n);
    badge.classList.toggle("filter-drawer-trigger__badge--hidden", n <= 0);
  }

  const summary = doc.querySelector('[data-filter-drawer-target="summary"]');
  if (summary) summary.textContent = filterSummaryText(n);
}

export function filterSummaryText(count) {
  if (count <= 0) return "No filters applied";
  return `${count} ${count === 1 ? "filter" : "filters"} applied`;
}

// Bridge for the inline DataTables dataSrc callback in _table.html.erb.
if (typeof window !== "undefined") {
  window.leadsSwapFilterChips = swapFilterChipsRegion;
  window.leadsUpdateFilterCount = updateFilterCount;
}
